
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "generateAnalyticsEmbedUrl",
      resolverType: "mutation",
      routePath: "/generateAnalyticsEmbedUrl",
      httpMethod: "POST",
    });
  